import { render, staticRenderFns } from "./ReferralInfoPanel.vue?vue&type=template&id=4c8be38a&scoped=true"
import script from "./ReferralInfoPanel.vue?vue&type=script&lang=js"
export * from "./ReferralInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./ReferralInfoPanel.vue?vue&type=style&index=0&id=4c8be38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8be38a",
  null
  
)

export default component.exports